export enum CustomEventNames {
  MKP_CHECKOUT_OPEN = 'mkpCheckoutOpen',
  MKP_ORDER_CONFIRMED = 'mkpOrderConfirmed',
}
